import { AxiosInstance } from 'axios';
import { BackendFilterModel } from 'types/backend';

export interface ICustomExportService {
  exportPrices(
    request: ExportPricesRequest,
    signal: AbortSignal
  ): Promise<boolean>;
}

export class CustomExportService implements ICustomExportService {
  constructor(private httpClient: AxiosInstance) {}

  async exportPrices(
    request: ExportPricesRequest,
    signal: AbortSignal
  ): Promise<boolean> {
    if (!request.filtersApplied) {
        request.filtersApplied = { items: [] };
    }

    const response = await this.httpClient.post(
      `/api/export/exportPriceSheetToExcel/${request.customerNumber}`,
      {
        FilterModel: request.filtersApplied,
        SortModel: [],
        pageSize: 0
      },
      {
        signal: signal,
        responseType: 'blob',
      }
    );

    if (response.status !== 200) return false;

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      response.headers['content-disposition']
        .split('filename=')[1]
        .split(';')[0]
        .replaceAll('"', '')
    );
    document.body.appendChild(link);
    link.click();

    return true;
  }
}

export interface ExportPricesRequest {
  customerNumber: string;
  filtersApplied: BackendFilterModel | undefined
}